import { Button, Group, Table, TextInput } from '@mantine/core';
import { IconPlus, IconTrash } from '@tabler/icons-react';

// One accessible name per row, or a query by role and name finds several elements as soon as a
// second row exists; the first row keeps the bare label.
const labelFor = (label, index) => (index === 0 ? label : `${label} ${index + 1}`);

const KeyValueMapper = ({
  rows,
  setRows,
  keyLabel = 'Key',
  valueLabel = 'Value',
  keyPlaceholder = 'Authorization',
  valuePlaceholder = 'Bearer <someToken>',
  addLabel = 'Add Variable',
  maxRows = Infinity,
  // Optional third input per row: { label, render(row, index, setRow) }.
  extraColumn,
}) => {
  const setRow = (i, row) => {
    const rowsCopy = structuredClone(rows);
    rowsCopy[i] = row;
    setRows(rowsCopy);
  };

  const deleteRow = (i) => setRows(structuredClone(rows).filter((_, index) => i !== index));

  return (
    <>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{keyLabel}</Table.Th>
            <Table.Th>{valueLabel}</Table.Th>
            {extraColumn && <Table.Th>{extraColumn.label}</Table.Th>}
            <Table.Th style={{ textAlign: 'right' }}>
              {' '}
              {rows.length < maxRows && (
                <Button size="sm" variant="default" onClick={() => setRows([...rows, { key: '', value: '' }])}>
                  <IconPlus size={14} /> {addLabel}
                </Button>
              )}
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.map((row, i) => {
            return (
              <Table.Tr key={i}>
                <Table.Td>
                  <TextInput
                    name="key"
                    size="sm"
                    type="text"
                    aria-label={labelFor(keyLabel, i)}
                    value={row.key}
                    placeholder={keyPlaceholder}
                    onChange={(e) => setRow(i, { ...row, [e.target.name]: e.target.value })}
                  />
                </Table.Td>
                <Table.Td>
                  <TextInput
                    name="value"
                    size="sm"
                    aria-label={labelFor(valueLabel, i)}
                    placeholder={valuePlaceholder}
                    value={row.value}
                    onChange={(e) => setRow(i, { ...row, [e.target.name]: e.target.value })}
                  />
                </Table.Td>
                {extraColumn && <Table.Td>{extraColumn.render(row, i, (next) => setRow(i, next))}</Table.Td>}
                <Table.Td>
                  <Group justify="flex-end">
                    <Button size="sm" variant="default" onClick={() => deleteRow(i)}>
                      <IconTrash size={14} />
                    </Button>
                  </Group>
                </Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </>
  );
};

export default KeyValueMapper;
